import { render, staticRenderFns } from "./BuyingLists.vue?vue&type=template&id=67117138&scoped=true"
import script from "./BuyingLists.vue?vue&type=script&lang=ts"
export * from "./BuyingLists.vue?vue&type=script&lang=ts"
import style0 from "./BuyingLists.vue?vue&type=style&index=0&id=67117138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67117138",
  null
  
)

export default component.exports